import { Stack, Typography } from '@montugroup/design-system';

export const ScriptUnsupported = () => {
  return (
    <Stack gap={6} sx={{ textAlign: 'center' }} data-testid="pharmacist-escript-script-unsupported">
      <Typography variant="subtitle1" fontWeight={600}>
        This prescription is ineligible
      </Typography>
      <Typography>Please try adding another new token for your customer</Typography>
    </Stack>
  );
};
